import * as Blockly from 'blockly';
import { FieldIconBase } from '@shared/blockly/fields';

const ICON_SIZE = 16;
const ICON_PADDING = 2;

/**
 * Custom Blockly field that renders a Remix Icon via foreignObject.
 * Usage in JSON: { type: 'field_icon', name: 'ICON', icon: 'ri-home-line' }
 */
export class FieldIcon extends FieldIconBase {
  private foreignObject_: SVGForeignObjectElement | null = null;
  private iconElement_: HTMLElement | null = null;

  override initView(): void {
    this.createBorderRect_();
    this.createIcon_();
    this.updateSize_();
  }

  private createIcon_(): void {
    if (!this.fieldGroup_) return;

    const fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    fo.setAttribute('width', `${ICON_SIZE + ICON_PADDING * 2}`);
    fo.setAttribute('height', `${ICON_SIZE + ICON_PADDING * 2}`);
    fo.setAttribute('y', '0');

    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.width = '100%';
    wrapper.style.height = '100%';

    const icon = document.createElement('i');
    icon.className = `${this.getValue()} ri-lg`;
    icon.style.color = '#fff';
    icon.style.fontSize = `${ICON_SIZE}px`;
    icon.style.lineHeight = '1';

    wrapper.appendChild(icon);
    fo.appendChild(wrapper);
    this.fieldGroup_.appendChild(fo);

    this.foreignObject_ = fo;
    this.iconElement_ = icon;
  }

  protected override updateSize_(): void {
    const totalWidth = ICON_SIZE + ICON_PADDING * 2;
    const totalHeight = ICON_SIZE + ICON_PADDING * 2;

    this.size_ = new Blockly.utils.Size(totalWidth, totalHeight);

    if (this.borderRect_) {
      this.borderRect_.setAttribute('width', `${totalWidth}`);
      this.borderRect_.setAttribute('height', `${totalHeight}`);
      this.borderRect_.style.fill = 'transparent';
      this.borderRect_.style.stroke = 'none';
    }
  }

  override showEditor_(): void {
    // Icon-Feld ist nicht editierbar
  }

  public override setIcon(iconClass: string): void {
    super.setIcon(iconClass);
    if (this.iconElement_) {
      this.iconElement_.className = `${iconClass} ri-lg`;
    }
  }
}
